<template>
  <div>
    <header
      class="flex flex-col items-center justify-between max-w-full md:max-w-6xl px-2 md:px-6 pb-12 mx-auto sm:flex-row"
    >
      <router-link to="/" class="z-10 order-last sm:order-first hidden md:block">
        <img src="@/assets/brands/pridge/logo.webp" alt="Pridge" class="h-12 w-auto" />
      </router-link>
      <nav class="z-10 order-first sm:order-last">
        <Social />
      </nav>
    </header>
    <router-view />
    <footer class="max-w-3xl mx-auto px-4 pt-6 pb-8 text-center text-sm text-gray-500">
      <a
        href="https://pdental.org"
        target="_blank"
        rel="noopener"
        class="flex flex-col sm:flex-row items-center justify-center gap-3 rounded-lg border border-solid border-gray-200 bg-white px-4 py-3 hover:bg-gray-100"
      >
        <img src="@/assets/logo.png" alt="PDental" class="h-8 w-auto" />
        <span class="text-gray-700">{{ $t("PDentalCta") }}</span>
        <span class="font-semibold text-blue-500 whitespace-no-wrap">{{ $t("PDentalCtaLink") }}</span>
      </a>
      <p class="mt-4 text-xs">
        {{ $t("BuiltBy") }}
        <a href="https://pdental.org" target="_blank" rel="noopener" class="font-semibold text-gray-700">PDental</a>
      </p>
    </footer>
  </div>
</template>

<script>
import Social from "@/components/Social.vue";
export default {
  name: "PridgeLayout",
  components: { Social },
};
</script>
